import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Typography } from '@mui/material';

import Tabs from '../../components/Tabs';
import Tab from '../../components/Tabs/Tab';
import { i18nNS } from '../../i18n';
import routes from '../../pages/routes';
import PublishInfo from '../Info/PublishInfo';
import PublishCourse from './PublishCourse';
import { AppBar } from './styles';
import { CourseTabs } from './types';
import useCourseHeaderVM, { CourseTabIds, CourseTabPanelIds } from './vm';

const CourseHeader = () => {
  const { t } = useTranslation([i18nNS.COURSES, i18nNS.GLOSSARY]);
  const { activeTab, canPublishInfo, params } = useCourseHeaderVM();
  return (
    <>
      <AppBar>
        <Tabs value={activeTab} centered aria-label={t('course_page_tabs', { ns: i18nNS.COURSES })}>
          <Tab
            id={CourseTabIds[CourseTabs.TIMELINE]}
            aria-controls={CourseTabPanelIds[CourseTabs.TIMELINE]}
            component={Link}
            to={routes.courseTimeline.url(params)}
            value={CourseTabs.TIMELINE}
            label={<Typography component="span">{t('timeline', { ns: i18nNS.GLOSSARY })}</Typography>}
          />
          <Tab
            id={CourseTabIds[CourseTabs.INFO]}
            aria-controls={CourseTabPanelIds[CourseTabs.INFO]}
            component={Link}
            to={routes.courseInfo.url(params)}
            value={CourseTabs.INFO}
            label={<Typography component="span">{t('info', { ns: i18nNS.GLOSSARY })}</Typography>}
          />
          <Tab
            id={CourseTabIds[CourseTabs.SYLLABUS]}
            aria-controls={CourseTabPanelIds[CourseTabs.SYLLABUS]}
            component={Link}
            to={routes.courseSyllabus.url(params)}
            value={CourseTabs.SYLLABUS}
            label={<Typography component="span">{t('syllabus', { ns: i18nNS.GLOSSARY })}</Typography>}
          />
        </Tabs>
      </AppBar>
      {activeTab === CourseTabs.TIMELINE && <PublishCourse />}
      {activeTab === CourseTabs.INFO && canPublishInfo && <PublishInfo />}
    </>
  );
};

export default CourseHeader;
